import { UserListDTO } from '../user/user-list.dto';

export class ParticipantListDTO {

    type: number;

    status: number;

    start: string | Date;

    end: string | Date;

    allDay: boolean;

    recurrence: string;

    duration: number;

    user: UserListDTO;

}
